import { split } from 'sentence-splitter';

/**
 * A wrapper on the sentence-splitter lib.
 * Add-on logic is to consider \n as indication of new sentence.
 */

export const splitIntoSentences = (para: string) => {
  const sentencesSplit = split(para);
  const newSentenceSplit: { type: string; raw: string }[] = [];
  sentencesSplit.forEach((s) => {
    if (s.type === 'Sentence') {
      const sentenceText = s.raw;
      const subSentences = sentenceText.split('\n');
      let linespace = '';

      subSentences.forEach((subSent) => {
        if (subSent.trim() === '') {
          linespace += '\n';
        } else {
          if (linespace !== '') {
            newSentenceSplit.push({ type: 'WhiteSpace', raw: linespace });
            linespace = '';
          }
          newSentenceSplit.push({ type: 'Sentence', raw: subSent });
          linespace += '\n';
        }
      });
    } else {
      newSentenceSplit.push(s);
    }
  });
  return newSentenceSplit;
};

export const sentenceCount = (para: string) =>
  splitIntoSentences(para).filter((sentence) => sentence.type === 'Sentence').length;
